import { useQuery } from "react-query";

const useCustomQuery = <T>({
  queryKey,
  queryFn,
  options,
}: {
  queryKey: string;
  queryFn: () => Promise<any>;
  options: any;
}) => {
  const { data, isLoading, isError, error } = useQuery(
    queryKey,
    queryFn,
    options
  );

  return { data, isLoading, isError, error };
};

export default useCustomQuery;
